import ApiError from "shared/components/feedback/modals/ErrorModal";
import Button from "shared/components/inputs/mui/Button";
import GenericModal from "shared/components/feedback/modals/common/GenericModal";
import React from "react";
import ReactDOM from "react-dom";

const ErrorTestPage = () => {
    const showModal = () => {
        const detail = {
            title: "Test",
            message: "Test",
            actionMessage: "Test",
        };
        const modalContent = <ApiError error="Error test" popup />;
        const modal = (
            <GenericModal
                content={modalContent}
                detail={detail}
                parent="divAppErrorModal"
            />
        );
        ReactDOM.render(modal, document.getElementById("divAppErrorModal"));
    };

    return (
        <Button
            style={{
                width: "11rem",
                height: "2.8rem",
                alignSelf: "center",
            }}
            onClick={() => showModal()}
        >
            Test Modal
        </Button>
    );
};

export default ErrorTestPage;
